import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, Progress } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";
import Image from "next/image";
import { DiamondIcon, FireIcon } from "../GamificationIcons";
export const GamificationUserCard = ({ points, streak, level: currentLevel, nextLevel, levelText, xpText, streakText, }) => {
    let levelProgress = 1;
    if (nextLevel) {
        const pointsNeeded = nextLevel.requiredPoints - currentLevel.requiredPoints;
        const pointsAdquired = points - currentLevel.requiredPoints;
        levelProgress = pointsAdquired / pointsNeeded;
    }
    return (_jsxs(Card.Root, { className: css({
            width: "fit-content",
            display: "flex",
            flexDirection: "column",
            minWidth: 10,
            minHeight: 50,
            justifyContent: "flex-start",
            borderRadius: 8,
            gap: 0,
            pl: 2,
            pr: 2,
            pt: 1,
            pb: 0,
            mt: 2,
        }), children: [_jsxs(Card.Header, { className: css({
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    mb: 1,
                    padding: 0,
                    gap: 2,
                }), children: [_jsx(Image, { width: 11, height: 11, src: currentLevel.icon, alt: currentLevel.name }), _jsxs(Card.Title, { className: css({
                            textStyle: "sm",
                        }), children: [levelText, " ", currentLevel.name] })] }), _jsx(Card.Body, { style: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    paddingInline: 0,
                    paddingBottom: 1,
                }, children: _jsx(Progress, { value: levelProgress, min: 0, max: 1, size: "xs" }) }), _jsxs(Card.Footer, { className: css({
                    gap: 1,
                    pb: 1,
                    justifyContent: "flex-start",
                    padding: 0,
                    paddingTop: 0,
                }), children: [_jsx(DiamondIcon, { variant: "active", size: 11 }), _jsxs(Card.Description, { className: css({
                            textStyle: "xs",
                            mr: 1,
                        }), children: [points, " ", nextLevel ? `/ ${nextLevel.requiredPoints} ` : null, xpText] }), streak > 0 && (_jsxs(_Fragment, { children: [_jsx(FireIcon, { variant: "active", size: 11 }), _jsxs(Card.Description, { className: css({
                                    textStyle: "xs",
                                }), children: [streak, " ", streakText] })] }))] })] }));
};
//# sourceMappingURL=GamificationUserCard.js.map